import React, { useState, useEffect } from 'react';

function ScrollTop() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <>
      {isVisible && (
        <a 
          href="#" 
          id="scroll-top" 
          className="scroll-top d-flex align-items-center justify-content-center"
          onClick={(e) => { e.preventDefault(); scrollToTop(); }}
        >
          <i className="bi bi-arrow-up-short"></i>
        </a>
      )}
    </>
  );
}

export default ScrollTop;
